// Odoo 348733 (замер Demo8 26.10, Graph DataHub, коннектор F&O 1002Q_001: 7 181 модель, 16 542 связи): ответ select сетевого графа
// (doc.params.graph_network = true — только граф DataHub) на границе «ответ → стор».
//
// 1) Строки без дубля. Бэк (widget_DS.select) строит _doc.data_graph из строк _doc.data: узел графа — ТОТ ЖЕ объект, что row.node1 строки
//    узла, ребро — тот же, что row.edge строки связи. JSON пишет их дважды: 13,56 МБ ответа, из них 5,72 МБ — вторая копия. Фронт, умеющий
//    собрать строки обратно, просит ответ без второй копии ключом запроса graph_rows_ref (только select сетевого графа); бэк
//    (common_modules/graph_rows_ref.py) ставит в строку на место объекта 0 и кладёт в _doc.data_graph_rows ссылки — серии
//    [строка, индекс в data_graph.nodes / edges, сколько подряд] по полю строки. Здесь, до записи в стор, на место каждого 0 встаёт КОПИЯ
//    объекта графа: строки и граф снова разные объекты, как после JSON — классика (graphology) меняет атрибуты узлов графа на месте, и
//    вкладка Sheet (колонки node1.* / edge.*) должна видеть значения бэка, как раньше. Ключи строки — в прежнем порядке (0 стоит на месте
//    поля). Старый фронт ключа не шлёт — ответ прежний байт в байт; новый фронт со старым бэком — ссылок нет, ничего не делаем.
// 2) Граф без глубокой реактивности. Данные графа в сторе — markRaw: AttrGraph отдаёт их в graphology как есть, и каждое чтение атрибута
//    (импорт, редьюсеры sigma на каждом кадре) шло через прокси Vue (замер Classic: ~0,5–0,9 с get/set-ловушек на открытии). Шаблоны
//    читают только объект целиком (data_graph.legend) и перерисовываются по замене record / data_graph — она остаётся реактивной.
//    Только сетевой граф: прочие графы (каскад, структура записи) — как раньше.
import { markRaw } from 'vue'

export const GRAPH_ROWS_REF_PARAM = 'graph_rows_ref'   // ключ запроса: фронт собирает строки по ссылкам
export const GRAPH_ROWS_REFS = 'data_graph_rows'       // ключ _doc ответа со ссылками
export const GRAPH_ROWS_REF_VERSION = 1

export const graphNetworkRecord = (rec) => !!(rec && rec.doc && rec.doc.params && rec.doc.params.graph_network === true)

// параметр запроса select: только сетевой граф, не опрос; выключатель fe.perf.graphRowsRef = false — прежний ответ с двумя копиями
export function graphRowsRef_requestParams(WIDGET, action, setting = null) {
    if (!action || action.method !== 'select' || action._isPoll) return {}
    if (!graphNetworkRecord(WIDGET && WIDGET.record)) return {}
    if (typeof setting === 'function' && setting('fe.perf.graphRowsRef', true) === false) return {}
    return { [GRAPH_ROWS_REF_PARAM]: 1 }
}

// глубокая копия значения JSON (объекты, массивы, примитивы) — порядок ключей прежний
export function jsonCopy(v) {
    if (v === null || typeof v !== 'object') return v
    if (Array.isArray(v)) { const a = new Array(v.length); for (let i = 0; i < v.length; i++) a[i] = jsonCopy(v[i]); return a }
    const o = {}
    for (const k in v) o[k] = jsonCopy(v[k])
    return o
}

// строки record._doc.data — обратно по ссылкам _doc.data_graph_rows (ключ снимается). null — ссылок нет; иначе {refs, bad, ms}:
// bad — ссылки, которые не сошлись (строки нет, на месте поля не 0, объекта графа нет) — поле остаётся как пришло
export function graphRowsRef_restore(record) {
    const doc = record && record._doc
    const refs = doc && doc[GRAPH_ROWS_REFS]
    if (!refs) return null
    const t0 = typeof performance !== 'undefined' ? performance.now() : Date.now()
    delete doc[GRAPH_ROWS_REFS]
    const rows = Array.isArray(doc.data) ? doc.data : null, dg = doc.data_graph || null
    let n = 0, bad = 0
    if (!rows || !dg || refs.v !== GRAPH_ROWS_REF_VERSION) bad = 1
    else {
        for (const kind of ['nodes', 'edges']) {
            const list = Array.isArray(dg[kind]) ? dg[kind] : [], byField = refs[kind] || {}
            for (const field of Object.keys(byField)) {
                for (const run of byField[field] || []) {
                    const [r0, k0, cnt] = run || []
                    for (let j = 0; j < cnt; j++) {
                        const row = rows[r0 + j], src = list[k0 + j]
                        if (!row || typeof row !== 'object' || row[field] !== 0 || !src || typeof src !== 'object') { bad++; continue }
                        row[field] = jsonCopy(src); n++
                    }
                }
            }
        }
    }
    const ms = (typeof performance !== 'undefined' ? performance.now() : Date.now()) - t0
    if (bad) console.warn(`graph answer: ${bad} row reference(s) did not resolve (${GRAPH_ROWS_REFS})`)
    return { refs: n, bad, ms: Math.round(ms * 10) / 10 }
}

// запись из ответа (updateDoc / updateWIDGET) — до записи в стор: строки по ссылкам, данные сетевого графа — markRaw
export function graphPayload_take(record) {
    if (!record || typeof record !== 'object' || !record._doc || typeof record._doc !== 'object') return null
    const st = graphRowsRef_restore(record)
    const dg = record._doc.data_graph
    if (graphNetworkRecord(record) && dg && typeof dg === 'object') markRaw(dg)
    return st
}
